module.exports = __webpack_public_path__ + "static/media/bridge5.6185d70f.jpg";